import Axios from 'axios'

Axios.defaults.withCredentials = true;
Axios.defaults.baseURL = process.env.VUE_APP_LIVE_URL_API;
Axios.defaults.headers.common['Accept'] = 'application/json';
Axios.defaults.headers.post['Content-Type'] = 'application/json';

Axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else if (!config.headers.Authorization) {
    delete config.headers.Authorization;
  }
  return config;
});

export function ensureCsrfCookie() {
  return Axios.get(`${process.env.VUE_APP_LIVE_URL}/sanctum/csrf-cookie`).catch(() => undefined);
}

export default Axios;
